<template>
    <div class="warning-modal">
        <span class="close" @click="$emit('exitModal')">&times;</span>
        <h2>Warning: Duplicate Codes</h2>
        <div class="warning-message">
            <p>Some of the benefits you are trying to add have codes that already exist in the plan. Adding these benefits may cause issues with integrations & benefit logging.</p>
            <p>Would you like to continue adding these benefits anyway?</p>
        </div>
        <div class="button-container">
            <button class="cancel-btn" @click="$emit('exitModal')">Cancel</button>
            <button class="continue-btn" @click="$emit('continue')">Continue Anyway</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DuplicateCodeWarningModal',
    emits: ['exitModal', 'continue']
}
</script>

<style scoped>
.warning-modal {
    background: white;
    padding: 2rem;
    border-radius: 8px;
    max-width: 500px;
    position: relative;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.close {
    position: absolute;
    right: 1rem;
    top: 1rem;
    font-size: 1.5rem;
    cursor: pointer;
    color: #666;
}

.close:hover {
    color: #333;
}

h2 {
    color: #dc3545;
    margin-top: 0;
    margin-bottom: 1.5rem;
}

.warning-message {
    margin-bottom: 2rem;
    color: #333;
    line-height: 1.5;
}

.warning-message p {
    margin: 0.5rem 0;
}

.button-container {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
}

button {
    padding: 0.5rem 1rem;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    border: none;
    transition: all 0.2s ease;
}

.cancel-btn {
    background-color: #f8f9fa;
    color: #333;
    border: 1px solid #ddd;
}

.cancel-btn:hover {
    background-color: #e9ecef;
}

.continue-btn {
    background-color: #dc3545;
    color: white;
}

.continue-btn:hover {
    background-color: #c82333;
}
</style> 